import { RefreshCw } from "lucide-react";
import { usePreparationRecheckWorkspace } from "./usePreparationRecheckWorkspace";
export function RecheckButtonView({ workspace }: { workspace: ReturnType<typeof usePreparationRecheckWorkspace> }) {
  const { loading, run } = workspace;
  return (
    <button
      type="button"
      className="material-preparation-recheck"
      disabled={loading}
      onClick={() => void run()}
    >
      <RefreshCw size={14} />
      {loading ? "Mikro okunuyor…" : "Mikro'dan yeniden kontrol et"}
    </button>
  );
}

export function RecheckButton(props: Parameters<typeof usePreparationRecheckWorkspace>[0]) {
  const workspace = usePreparationRecheckWorkspace(props);
  return <RecheckButtonView workspace={workspace} />;
}
